export default "__VITE_ASSET__DkSsrOmx__"